export const BASE_PATH=process.env.REACT_APP_BASE_URL;

export const SAML_API_PATH=process.env.REACT_APP_SAML_BACKEND;

export const ENV = process.env.REACT_APP_ENV;

export const SOURCE = process.env.REACT_APP_SOURCE;

export const MOBILE_SOURCE = process.env.REACT_APP_MOBILE_SOURCE;

export const CUSTOM_POLICY_AUTHORITY = process.env.REACT_APP_CUSTOM_POLICY_AUTHORITY;
